import * as actions from './actionTypes';

export default function reducer(state = {currentUser: {}, feedPosts: [], currentUserPosts: {}, currentProfileViewPosts: [], allUsers: []}, action) {
    switch(action.type) {
        case actions.LOGGED_IN:
            state["currentUser"] = action.payload.currentUser;
            return {
                ...state,
                currentUser : action.payload.currentUser,
            }
        case actions.LOGGED_OUT:
            state["currentUser"] = null;
            return {
                ...state
            };
        case actions.FETCH_FEED_POSTS:
            const feedPosts = action.payload.feedPosts
            return {
                ...state,
                feedPosts: feedPosts
            };
        case actions.FETCH_USER_POSTS:
            const currentUserPosts = action.payload.currentUserPosts
            return {
                ...state,
                currentUserPosts: currentUserPosts
            }
        case actions.LIKE_POST:
            //console.log(action.payload.postObject)
            const post = action.payload.postObject
            post['likes'] = action.payload.postObject.likes + 1
            return {
                ...state,
                feedPosts: {
                    ...state.feedPosts
                },
                currentUserPosts: {
                    ...state.currentUserPosts
                },
                currentProfileViewPosts: {
                    ...state.currentProfileViewPosts
                }
            }
        case actions.SAVE_POST:
            const postObject = action.payload.postObject
            postObject['saves'] = action.payload.postObject.saves + 1
            return {
                ...state,
                feedPosts: {
                    ...state.feedPosts
                },
                currentUserPosts: {
                    ...state.currentUserPosts
                }
            }
        case actions.UNLIKE_POST:
            const postss = action.payload.postObject
            postss['likes'] = action.payload.postObject.likes - 1
            return {
                ...state,
                feedPosts: {
                    ...state.feedPosts
                },
                currentUserPosts: {
                    ...state.currentUserPosts
                }
            }
        case actions.UNSAVE_POST:
            const postObjectss = action.payload.postObject
            postObjectss['saves'] = action.payload.postObject.saves - 1
            return {
                ...state,
                feedPosts: {
                    ...state.feedPosts
                },
                currentUserPosts: {
                    ...state.currentUserPosts
                }
            }
        case actions.FETCH_PROFILE_VIEW_POSTS:
            const currentProfileViewPosts = action.payload.postObject
            return {
                ...state,
                currentProfileViewPosts: currentProfileViewPosts
            }
        case actions.FETCH_ALL_USERS:
            const allUsers = action.payload.allUsers
            return {
                ...state,
                allUsers: allUsers
            }
        default:
            return state
    }
}